<template>
  <StateChip :text="text" :variation="variation" />
</template>

<script setup lang="ts">
import { ChatMessageSendingJobStatus } from '@/types/schema.generated'
import { computed } from 'vue'
import StateChip from '@/components/atoms/StateChip.vue'

const { status } = defineProps<{
  status: ChatMessageSendingJobStatus
}>()

const text = computed(() => {
  switch (status) {
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusCompleted:
      return '完了'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusPending:
      return '予約済'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusRunning:
      return '実行中'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusFailed:
      return '失敗'
  }
  return '予定'
})

const variation = computed(() => {
  switch (status) {
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusCompleted:
      return 'positive'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusPending:
      return 'negative'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusRunning:
      return 'running'
    case ChatMessageSendingJobStatus.ChatMessageSendingJobStatusFailed:
      return 'alert'
  }
  return 'negative'
})
</script>
